import moment from 'moment'
import config from 'config'

const { api: apiDateFormat } = config.dateFormat

const getDate = (period) => {
  let startDate, endDate

  switch (period) {
    case 'currentMonth':
      startDate = moment().startOf('month').format(apiDateFormat)
      endDate = moment().endOf('month').format(apiDateFormat)
      break
    case 'lastMonth':
      startDate = moment().subtract(1, 'M').startOf('month').format(apiDateFormat)
      endDate = moment().subtract(1, 'M').endOf('month').format(apiDateFormat)
      break
    case 'secondLastMonth':
      startDate = moment().subtract(2, 'M').startOf('month').format(apiDateFormat)
      endDate = moment().subtract(2, 'M').endOf('month').format(apiDateFormat)
      break
    case 'currentQuarter':
      startDate = moment().startOf('quarter').format(apiDateFormat)
      endDate = moment().endOf('quarter').format(apiDateFormat)
      break
    case 'lastQuarter':
      startDate = moment().subtract(1, 'quarter').startOf('quarter').format(apiDateFormat)
      endDate = moment().subtract(1, 'quarter').endOf('quarter').format(apiDateFormat)
      break
    case 'secondLastQuarter':
      startDate = moment().subtract(2, 'quarter').startOf('quarter').format(apiDateFormat)
      endDate = moment().subtract(2, 'quarter').endOf('quarter').format(apiDateFormat)
      break
    case 'custom':
      startDate = moment().startOf('year').format(apiDateFormat)
      endDate = moment().endOf('year').format(apiDateFormat)
      break
  }

  return { startDate, endDate }
}

const getPeriodOptions = () => {
  // const currentYear = moment().format('YYYY')
  // const lastYear = moment(currentYear).subtract(1, 'year').format('YYYY')
  const currentMonthLabel = moment().format('MMMM YYYY')
  const lastMonthLabel = moment().subtract(1, 'month').format('MMMM YYYY')
  const secondLastMonthLabel = moment().subtract(2, 'month').format('MMMM YYYY')
  const currentQuarterLabel = `${moment().format('Q')}. Quartal ${moment().format('YYYY')}`
  const lastQuarterLabel = `${moment().subtract(1, 'quarter').format('Q')}. Quartal ${moment().subtract(1, 'quarter').format('YYYY')}`
  const secondLastQuarterLabel = `${moment().subtract(2, 'quarter').format('Q')}. Quartal ${moment().subtract(2, 'quarter').format('YYYY')}`

  const options = [
    { label: currentMonthLabel, value: 'currentMonth' },
    { label: lastMonthLabel, value: 'lastMonth' },
    { label: secondLastMonthLabel, value: 'secondLastMonth' },
    { label: currentQuarterLabel, value: 'currentQuarter' },
    { label: lastQuarterLabel, value: 'lastQuarter' },
    { label: secondLastQuarterLabel, value: 'secondLastQuarter' },
    { label: 'Benutzerdefiniert', value: 'custom' },
  ]

  return options.map((option) => {
    const { value } = option
    const { startDate, endDate } = getDate(value)

    return { ...option, startDate, endDate }
  })
}

export default getPeriodOptions
